<template>
    <Layout>
        <div class="container pt-2">
            <div class="no-free-will">
                <div class="row">
                    <div class="col-md-12">
                        <h2>Login</h2>
                        <p class="mb-0">Logging in to an account is limited for the users who were invited to the event and received their username and password.</p>
                    </div>
                </div>
            </div>
        </div>
        <form >
            <section class="section section-sm">
                <div class="container">
                    <div class="no-free-will">
                        <div class="row">
                            <div class="col-md-12">
                                <fieldset>
                                    <legend>Login Details</legend>
                                    <div class="alert alert-danger" v-if="errorMsg != ''">
                                         {{ errorMsg }}
                                    </div>
                                    <p>Please type in your username and password and then click on the Submit button.</p>
                                    <table>
                                        <tr><td>
                                            <div class="form-group" :class="{ 'has-error': $v.username.$error }">
                                                <label> Username <span>*</span></label>
                                                <input v-model="username" type="text" />
                                                  <small class="text-danger" v-if="!$v.username.required">Field is required</small>
                                            </div>
                                        </td></tr>
                                        <tr><td>
                                           <div class="form-group" :class="{ 'has-error': $v.password.$error }">
                                                <label> Password <span>*</span></label>
                                                <input v-model="password" type="password" />
                                                <small class="text-danger" v-if="!$v.password.required">Field is required</small>
                                            </div>
                                        </td></tr>
                                        <tr>
                                            <a href="/auth/password/email">Forgot password</a>
                                        </tr>
                                    </table>
                                </fieldset>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section class="section section-sm">
                <div class="container">
                    <div class="no-free-will">
                        <div class="row">
                            <div class="col-md-8">
                                <input @click.prevent="loginFormSubmitted" :disabled="!enableLoggin" value="Submit" type="submit" class="btn btn-outline-clr btn-sm" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </form>
    </Layout>
</template>

<script>
import Layout from '@/components/layouts/Layout.vue'
import { required } from 'vuelidate/lib/validators'
import Api from '@/Api'
export default {
    name: 'login',
    components: {Layout},
    data() {
        return {
            username: "",
            password:"",
            enableLoggin: true,
            errorMsg : '',
        };
    },
    validations: {
        username: {
          required,
        },
        password: {
          required
        },
    },
    methods: {
        loginFormSubmitted() {
            var scope = this;
            scope.errorMsg = '';

            if (this.$v.$invalid)
                return;

            let data = {
                name: this.username,
                password: this.password,
            };

            Api().post('auth/signin', data).then((response) => {
                let user = response.data.user;
                if(user)
                {
                    this.$store.dispatch("login", {
                        user: user,
                      }).then((isFinished) => {
                        if (isFinished) {
    
                            let redirect = this.$route.query.redirect;
                            localStorage.setItem("firstTimeRegister" , "0" );
                            window.location = redirect ? redirect : '/';
                        }
                      });
                }
                else throw new Error('');
            }).catch((error) => {
                // console.log(error)
                if (error) {
                    if (error.response && error.response.status == 422) {
                        var err = error.response.data;
                        scope.errorMsg = err.errors[0].message;
                    } else {
                        scope.errorMsg = "Something Went Wrong";
                    }
                } 
            });

        }
    }
}
</script>

<style scoped>
.pt-2 {
    padding-top: 2em;
}
.mb-0 {
    margin-bottom: 0;
}
@media screen and (max-width: 62em) {
    .pt-2 {
        padding-top: 10em;
    }
}
</style>
